import { useEffect, useRef, useState } from "react";
import { getUserApi } from "../api";

type BootstrapState = "idle" | "polling" | "ready";

export function useUserObjectExists(userId: string | null, enabled: boolean) {
    const [state, setState] = useState<BootstrapState>("idle");
    const timeoutLength = useRef(1000)

    useEffect(() => {
        if (!enabled || !userId) {
            setState("idle");
            return;
        }

        let cancelled = false;
        let timeoutId: number | undefined;

        const poll = async () => {
            if (cancelled) return;
            setState("polling");

            try {
                const user = await getUserApi(userId);

                if (cancelled) return;

                if (user) {
                    setState("ready");
                    return;
                }

                timeoutId = window.setTimeout(poll, timeoutLength.current);
            } catch (err) {
                if (!cancelled) console.error(err instanceof Error ? err.message : "Failed to check account status");
                timeoutId = window.setTimeout(poll, timeoutLength.current);
            } finally {
                timeoutLength.current = timeoutLength.current >= 20000 ? 20000 : timeoutLength.current + 1000;
            }
        };

        void poll();

        return () => {
            cancelled = true;
            timeoutLength.current = 1000;
            if (timeoutId) window.clearTimeout(timeoutId);
        };
    }, [enabled, userId]);

    return { userBootstrapState: state };
}
